/*
 * @Author: your name
 * @Date: 2020-12-09 13:56:59
 * @LastEditTime: 2021-02-22 16:04:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /fe-yanjiusheng-h5/src/components/Layout/index.js
 */

/* global VConsole */
import React from 'react'
import Tools from '../../util/tools'
import FixedFooterNav from '../FixedFooterNav'
import './index.scss'

const GET = Tools.GET
if (GET.isDebug) {
  const vconsole = new VConsole()
}
if (GET.token) {
  // App登录token
  const user = Tools.getLocalStorage('userLoginData') || {}
  user.token = GET.token
  Tools.setLocalStorage('userLoginData', user)
}
/* window.addEventListener('pageshow', function(event) {
  console.log("PageShow Event  " + event.persisted);
  if(event.persisted) {
    window.location.reload();
  }
}); */
var isPageHide = false
window.addEventListener('pageshow', function () {
  console.log('PageShow Event  ' + isPageHide)
  if (isPageHide) {
    window.location.reload()
  }
})
window.addEventListener('pagehide', function () {
  isPageHide = true
  console.log('PageHide Event  ' + isPageHide)
})

const Layout = ({
  className = '',
  activeNav = '',
  enableNav,
  ...originProps
}) => {
  const props = Object.assign({}, originProps)
  const isActive = activeNav.length > 0 || enableNav
  return (
    <div
      className={'layout' + (isActive ? ' layout-with-nav' : ' ') + className}
    >
      {<>{props.children}</>}
      {isActive ? (
        <FixedFooterNav activeNav={activeNav ? activeNav : null} />
      ) : null}
    </div>
  )
}

export default Layout
